<template>
  <span v-if="props.anchor" :id="props.anchor" class="anchor"></span>
  <div class="card" v-bind="$attrs">
    <h4 class="card-header text-uppercase bg-primary">Fichiers</h4>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="fw-semibold">Visuel principal</div>
          <FileUploadComponent
            type="image"
            :value-key="`mainPicture`"
            :required="false"
            class="mb-3"
            height="150px"
            :display-max-height="150"
            :hide-icon="false"
            display="cover"
          />
        </div>
        <div class="col-12">
          <div class="fw-semibold">Bloc-Titre</div>
          <FileUploadComponent
            type="image"
            :value-key="`titleBanner`"
            :required="false"
            class="mb-3"
            height="150px"
            :display-max-height="150"
            :hide-icon="false"
            display="contains"
          />
          <SelectInputComponent
            value-key="titleBannerAlignment"
            label="Alignement du bloc-titre"
            placeholder="Sélectionnez un alignement"
            :required="true"
            class="mb-3"
            :options="Object.values(TravelDbTitleBannerAlignmentEnum).map(a => ({ value: a, label: GetTitleBannerAlignmentLabel(a) }))"
          />
        </div>
        <div class="col-12">
          <div class="fw-semibold">Logo</div>
          <FileUploadComponent
            type="image"
            :value-key="`logo`"
            :required="false"
            class="mb-3"
            height="150px"
            :display-max-height="150"
            :hide-icon="false"
            display="contains"
          />
        </div>
        <div class="col-12">
          <div class="fw-semibold">Logo Compact <small class="text-muted fst-italic">(utilisé dans le PDF Web inscription)</small></div>
          <FileUploadComponent
            type="image"
            :value-key="`logoCompact`"
            :required="false"
            class="mb-3"
            height="150px"
            :display-max-height="150"
            :hide-icon="false"
            display="contains"
          />
        </div>
        <div class="col-12">
          <div class="fw-semibold">Bannière</div>
          <FileUploadComponent
            type="image"
            :value-key="`banner`"
            :required="false"
            class="mb-3"
            height="150px"
            :display-max-height="150"
            :hide-icon="false"
            display="contains"
          />
        </div>
        <div class="col-12">
          <div class="fw-semibold">Roadbook</div>
          <FileUploadComponent
            type="pdf"
            :value-key="`roadBook`"
            :required="false"
            class="mb-3"
            height="150px"
            :display-max-height="150"
            :mime-type="'application/pdf'"
            description="Fichier PDF uniquement de moins de 10 Mo"
            icon="<i class='fa-regular fa-file-pdf fa-3x'></i>"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import SelectInputComponent from '@/components/common/SelectInputComponent.vue';
import { GetTitleBannerAlignmentLabel } from '@/compositions/helper';
import * as zod from 'zod';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const travel = defineModel<AdminTravel>({ required: true });
const validationSchema = defineModel<{ shape: zod.ZodRawShape, anchors?: Record<string, string | undefined> }>('validation-schema',{ required: false, default: () => ({ shape: {} }) });

const props = defineProps<{
  anchor?: string
}>();

onMounted(() => {
  validationSchema.value = {
    shape: {
      mainPicture: zod.object({
        id: zod.number().nonnegative(),
        mimeType: zod.string(),
        base64Content: zod.string().optional(),
        key: zod.string()
      }).nullish(),
      titleBanner: zod.object({
        id: zod.number().nonnegative(),
        mimeType: zod.string(),
        base64Content: zod.string().optional(),
        key: zod.string()
      }).nullish(),
      logo: zod.object({
        id: zod.number().nonnegative(),
        mimeType: zod.string(),
        base64Content: zod.string().optional(),
        key: zod.string()
      }).nullish(),
      logoCompact: zod.object({
        id: zod.number().nonnegative(),
        mimeType: zod.string(),
        base64Content: zod.string().optional(),
        key: zod.string()
      }).nullish(),
      banner: zod.object({
        id: zod.number().nonnegative(),
        mimeType: zod.string(),
        base64Content: zod.string().optional(),
        key: zod.string()
      }).nullish(),
      roadBook: zod.object({
        id: zod.number().nonnegative(),
        mimeType: zod.string(),
        base64Content: zod.string().optional(),
        key: zod.string()
      }).nullish(),
      titleBannerAlignment: zod.nativeEnum(TravelDbTitleBannerAlignmentEnum, { message: 'Alignement du bloc-titre non valide' })
    },
    anchors: {
      mainPicture: props.anchor,
      logo: props.anchor,
      logoCompact: props.anchor,
      banner: props.anchor,
      roadBook: props.anchor
    }
  }
});
</script>
